import { WarningIcon } from 'components/shared/PriceNext';
import { FormattedMessage } from 'react-intl';

const ExpiredStatus = ({ hasBackendMessage }: { hasBackendMessage: boolean }) => (
  <div className="d-flex align-items-center gap-2 text-warning h-100 px-3 flex-grow-1">
    <span className="quote-ico icon">history_toggle_off</span>
    <span className="flex-grow-1">
      <FormattedMessage id="secondary-market-batch-grid.operation.status.expired" />
    </span>
    {hasBackendMessage && WarningIcon}
  </div>
);

export default ExpiredStatus;
